/**
 * A tenant's lifecycle status (TO-306, design D3). Persisted on the existing
 * `tenants.is_active` column — `ACTIVE ⇔ true`, `SUSPENDED ⇔ false` — which the
 * auth boundary's principal resolver already reads, so a suspended tenant's
 * principals are refused on their next request without any auth-path change.
 * Soft-delete stays on `deletedAt`; there is deliberately no DELETED member.
 */
export enum TenantStatus {
	ACTIVE = 'ACTIVE',
	SUSPENDED = 'SUSPENDED',
}

export interface ITenant {
	tenantId: string
	name: string
	slug: string
	isActive: boolean
	createdAt: Date
	updatedAt: Date
	deletedAt?: Date | null
}
